import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';


export const USE_HSA_CUSTODIAN_QUERY_KEY = 'useHsaCustodian';

export default () => {
  const { isLoading, error, data, isSuccess, isError, isFetching } = useQuery(
    [USE_HSA_CUSTODIAN_QUERY_KEY],
    () => api.get(API_URL.ENUMS_HSA_CUSTODIANS)
  );

  const formatedData = useMemo<Option[]>(
    () => [
      ...(data?.data || []).map(
        (item): Option => ({
          key: `${item.id}`,
          value: item.description,
        })
      ),
    ],
    [data]
  );
  return useMemo(
    () => ({
      data: formatedData,
      error,
      isError,
      isLoading,
      isSuccess,
      isFetching,
    }),
    [formatedData, error, isError, isLoading, isSuccess, isFetching]
  );
};
